import React, { useEffect, useState } from "react";
import NavBar from "../components/Navigation/NavBar";
import { getCardColorIdx, getConfigV1, getConstant, handleHeader } from "../services/functions";
import { BASE_URL, DETAILS_PATH } from "../utility/path";
import axios from "axios";
import MainContainer from "../components/MainContainer";
import { useDispatch, useSelector } from "react-redux";
import CustomImage from "../components/CustomImage";
import { useNavigate } from "react-router-dom";
import logo from '../logo.png';
import "../card.css"
import Card from "../components/Card";
import { detailsAction } from "../redux/slices/detailsSlice";
import BottomNav from "../components/Navigation/BottomNav";

const Favourite = () => {
    let idx = 1;
    const [state, setState] = useState();
    const authData = useSelector((state) => state?.auth?.data);
    const [showTransition, setShowTransition] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        handleHeader({ ...getConstant("FAVOURITES") }, dispatch);
        setShowTransition(true);
        loadData();

        return () => { setShowTransition(false) }
    }, []);

    const handleClick = input => e => {
        console.log('input',input);
        if(input){
            return navigate(input);
        }
    }

    const loadData = async () => {
        try {
            const config = getConfigV1('',authData);
            const { data } = await axios.get(
                `${BASE_URL}/api/users/profile?id=${authData?.id}`,          
                config
              );
            //console.log(data);

            if (data) {
                setState(data);
            }

        } catch (error) {
            console.log(error?.message)
        }
    }

    const openDetailsPage = async (input) => {
        if (!input) {
            console.log('return')
            return;
        }
        const redirectPath = `/details/${input}`;
        handleHeader({ ...getConstant("FAVOURITES_DETAILS") }, dispatch);
        navigate(redirectPath);
    }

    return (

        <>
            <NavBar />
            <MainContainer>
            <h5>Favourites</h5>
            {!state?.following?.length && <div className="nf-empty">
                <i className="fa fa-heart-o nf-empty__icon" />
                <p>No favourites yet</p>
            </div>}

            <div className="cards_ct">
            {state?.following?.map((el,idx) => (
                // <div key={idx} className={`card_ct card-${getCardColorIdx(idx)} show-transition ${showTransition ? "show" : ""}`} onClick={handleClick(`/details/${el?.id}`)}>
                //     <div className="card__icon d-flex" >
                //         <CustomImage state={{ image:el?.profilePhoto || logo, name: el?.name }} className="thumbnail circle" size={"3rem"} />
                //         <div className="p-1 text-truncate">
                //             {el?.name?.toLowerCase()} 
                //         </div>
                //     </div>
                //     <div className="card__title">{el?.category?.[0]?.name}</div>
                //     <p className="card__apply">
                //         <span className="card__link">Contact</span>
                //     </p>
                // </div>      
                <Card key={idx} idx={idx} user={el} openDetailsModal={openDetailsPage} />
            ))}
            {/* {!state?.following?.length && (<li className="notification-item bg-light mb-2 p-1 border border-light rounded">No favourites available</li>)} */}
            </div>

            </MainContainer>
            <BottomNav/>
        </>
    );
};

export default Favourite;